import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';
import { mccCodes as staticMccCodes } from '../utils/mccCodes';

const MccContext = createContext();

export const useMccCodes = () => useContext(MccContext);

export const MccProvider = ({ children }) => {
    // Initialize with static codes to avoid empty flash
    const [codes, setCodes] = useState([]);
    const [categories, setCategories] = useState([]);
    const [codesMap, setCodesMap] = useState(staticMccCodes);

    const fetchCodes = async () => {
        try {
            const res = await axios.get('/mcc-codes');
            if (res.data && res.data.length > 0) {
                setCodes(res.data);
                const newMap = {};
                // If the user hasn't edited anything, we might want to merge with static?
                // But DB should be source of truth.
                // We'll trust the DB. migration populated it.
                res.data.forEach(c => {
                    newMap[c.code] = c.description;
                });
                setCodesMap(newMap);
            }
        } catch (error) {
            console.error("Failed to fetch MCC codes", error);
        }
    };

    const fetchCategories = async () => {
        try {
            const res = await axios.get('/mcc-categories');
            setCategories(res.data || []);
        } catch (error) {
            console.error("Failed to fetch MCC categories", error);
        }
    };
    
    const refreshCodes = () => {
        fetchCodes();
        fetchCategories();
    };

    useEffect(() => {
        fetchCodes();
        fetchCategories();
    }, []);

    const getMccDescription = (code) => {
        return codesMap[code] || "Unknown Category";
    };

    return (
        <MccContext.Provider value={{ codes, categories, getMccDescription, refreshCodes }}>
            {children}
        </MccContext.Provider>
    );
};
